import { DemoOrderData } from '../../interfaces/demo'
import Api from '../Api'

export async function order(data: DemoOrderData) {
  const response = await Api.post('/order_demo', data)
  return response.data
}
